import React from 'react';
import PropTypes from 'prop-types';

import SplitText from '../SplitText';

const Event = ({ content }) => {
  return <SplitText>{content.text}</SplitText>;
};

Event.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired
  }).isRequired
};

export default Event;
